// Where a binder under review came from. An internal binder is attached to a policy that
// already exists, so completing its review overrides that policy; an external one was
// uploaded to create a policy that does not exist yet.
export type BinderReviewSource = 'internal' | 'external';

export type BinderReviewStatus = 'processing' | 'ready' | 'reviewed' | 'failed' | 'discarded';

// A reviewer can still act on these. The API takes `pending` as shorthand for both.
// Failed is not one of them -- there is nothing to open, so it sits behind its own filter
// rather than in the queue.
export const PENDING_BINDER_REVIEW_STATUS = 'pending';

export interface BinderReviewItem {
  source: BinderReviewSource;
  // Absent while the extraction is still running -- an item without one cannot be opened.
  promptResultId?: number;
  submissionId?: number;
  documentId: number;
  documentName: string;
  policyId?: string;
  policyNumber?: string;
  // The policy the review would update. Absent on an external binder, which has no policy
  // until its submission is confirmed.
  policyEffectiveDate?: string;
  status: BinderReviewStatus;
  errorMessage?: string;
  // Absent on a document that arrived through an ETL rather than a person.
  uploadedBy?: string;
  uploadedAt: string;
  scannedAt?: string;
  reviewedBy?: string;
  reviewedAt?: string;
  updatedAt: string;
}

// Narrows the account's list. Omitting status means every status; `page` and `size`
// together ask for one page instead of the whole sequence.
export interface BinderReviewQuery {
  status?: string;
  source?: BinderReviewSource | '';
  search?: string;
  page?: number;
  size?: number;
}

export interface BinderReviewListResponse {
  items: BinderReviewItem[];
  // Everything matching the filter, so a paged caller can size its pager.
  total: number;
  // Unpaged only: the account has more results than the endpoint returns, so the sequence
  // Back/Next walks is not the whole set.
  truncated: boolean;
}
